import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Heading } from './Heading';
import { SwitchInput } from '../../../../../../../common/react/components/SwitchInput';
import {
    seasonSelector,
    roundSelector,
    statsLeadersSortSelector,
    statsLeadersBenchmarkingSelector
} from '../../../../../store/js/modules/statspro/stats-leaders/selectors';
import {
    composeGetTranslation,
    getTranslation
} from '../../../../../../../common/react/utils/translations';
import { UPDATE_BENCHMARKING } from '../../../../../store/js/modules/statspro/stats-leaders/actions';
import { ToggleInput } from '../../../../../../../common/react/components/ToggleInput';
import { useDataType } from './hooks/use-data-type';
import { DATA_TYPE } from '../config/data-type';

export const StatsLeadersTableHeader = () => {
    const dispatch = useDispatch();
    const sort = useSelector( statsLeadersSortSelector );
    const benchmarking = useSelector( statsLeadersBenchmarkingSelector );
    const season = useSelector( seasonSelector );
    const round = useSelector( roundSelector );

    const { dataType, updateDataType } = useDataType();

    const getDataTypeTranslation = composeGetTranslation( 'label.statsLeaders.dataType.' );

    return (
        <div className="stats-leaders-table-header">

            <Heading { ...{ sort, season, round } } />

            <div className="stats-leaders-table-header__options-wrapper">
                <div className="stats-leaders-table-header__benchmarking-switch">
                    <SwitchInput
                        id="benchmarking-toggle"
                        label={ getTranslation( 'label.statsLeaders.benchmarking.toggleText' ).toUpperCase() }
                        isChecked={ benchmarking.isActive }
                        onChange={ isActive => dispatch( UPDATE_BENCHMARKING.request( { isActive } ) ) }
                    />
                </div>
                <div className="stats-leaders-table-header__data-type-toggle">
                    <ToggleInput
                        id="data-type-toggle"
                        value={ dataType.type.toLowerCase().includes( DATA_TYPE.TOTALS ) ? DATA_TYPE.TOTALS : DATA_TYPE.AVERAGES }
                        onChange={ updateDataType }
                        options={ [
                            {
                                label: getDataTypeTranslation( DATA_TYPE.TOTALS ),
                                value: DATA_TYPE.TOTALS
                            },
                            {
                                label: getDataTypeTranslation( DATA_TYPE.AVERAGES ),
                                value: DATA_TYPE.AVERAGES,
                                disabled: !!round
                            }
                        ] }
                    />
                </div>
            </div>
        </div>
    );
};
